import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { MapPinIcon, RouteIcon, TreesIcon, WavesIcon, BuildingIcon } from 'lucide-react';
const rides = [{
  name: 'Tunnel of Trees (M-119)',
  distance: '20 miles',
  location: 'Harbor Springs to Cross Village',
  description: "One of America's most scenic drives. Winding road through a canopy of trees along Lake Michigan. Best in fall for colors.",
  icon: TreesIcon,
  highlight: 'Lake Michigan views'
}, {
  name: 'Copper Harbor Loop',
  distance: '~150 miles',
  location: 'Upper Peninsula',
  description: 'Remote wilderness riding through the Keweenaw Peninsula. Stunning views, minimal traffic, and the feeling of being at the edge of the world.',
  icon: MapPinIcon,
  highlight: 'UP wilderness'
}, {
  name: 'River Road Scenic Byway',
  distance: '22 miles',
  location: 'Huron National Forest',
  description: 'Follows the Au Sable River through national forest. Peaceful, tree-lined route with access to hiking and fishing spots.',
  icon: TreesIcon,
  highlight: 'Forest scenery'
}, {
  name: 'US-2 Lake Michigan',
  distance: '~90 miles',
  location: 'St. Ignace to Naubinway',
  description: 'Upper Peninsula shoreline ride with breathtaking lake views. Stop at roadside parks and small UP towns along the way.',
  icon: WavesIcon,
  highlight: 'Shoreline views'
}, {
  name: 'Woodward Avenue',
  distance: '~25 miles',
  location: 'Detroit to Pontiac',
  description: "America's first paved road and the heart of car culture. Best during the annual Dream Cruise in August.",
  icon: BuildingIcon,
  highlight: 'Historic cruise route'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function BestRides() {
  return <div className="min-h-screen bg-[#0a0a0a] safe-bottom" data-id="element-57">
      <PageHeader title="5 Best MI Rides" subtitle="Scenic routes every Michigan rider should experience" data-id="element-58" />

      <main className="px-4 py-6" data-id="element-59">
        <motion.div className="space-y-4" variants={container} initial="hidden" animate="show" data-id="element-60">
          {rides.map((ride, index) => {
          const Icon = ride.icon;
          return <motion.div key={index} variants={item} className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl overflow-hidden" data-id="element-61">
                {/* Header */}
                <div className="bg-[#252525] px-4 py-3 flex items-center justify-between" data-id="element-62">
                  <div className="flex items-center gap-3" data-id="element-63">
                    <div className="w-8 h-8 rounded-lg bg-[#22c55e]/10 flex items-center justify-center" data-id="element-64">
                      <span className="text-[#22c55e] font-bold text-sm" data-id="element-65">
                        {index + 1}
                      </span>
                    </div>
                    <h3 className="font-bold text-white" data-id="element-66">{ride.name}</h3>
                  </div>
                  <div className="flex items-center gap-1 text-[#a3a3a3]" data-id="element-67">
                    <RouteIcon className="w-4 h-4" data-id="element-68" />
                    <span className="text-xs" data-id="element-69">{ride.distance}</span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-4" data-id="element-70">
                  <div className="flex items-center gap-2 mb-2" data-id="element-71">
                    <MapPinIcon className="w-4 h-4 text-[#d4a853]" data-id="element-72" />
                    <span className="text-sm text-[#d4a853]" data-id="element-73">
                      {ride.location}
                    </span>
                  </div>
                  <p className="text-[#a3a3a3] text-sm leading-relaxed mb-3" data-id="element-74">
                    {ride.description}
                  </p>
                  <div className="inline-flex items-center gap-2 bg-[#22c55e]/10 px-3 py-1 rounded-full" data-id="element-75">
                    <Icon className="w-4 h-4 text-[#22c55e]" data-id="element-76" />
                    <span className="text-xs text-[#22c55e] font-medium" data-id="element-77">
                      {ride.highlight}
                    </span>
                  </div>
                </div>
              </motion.div>;
        })}
        </motion.div>

        {/* Tip */}
        <motion.div className="mt-6 bg-[#d4a853]/10 border border-[#d4a853]/30 rounded-2xl p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} data-id="element-78">
          <p className="text-[#d4a853] font-semibold mb-2" data-id="element-79">🏍️ Riding Tip</p>
          <p className="text-[#a3a3a3] text-sm" data-id="element-80">
            The best riding season in Michigan is May through October. Fall
            colors peak in late September to mid-October—perfect for the Tunnel
            of Trees.
          </p>
        </motion.div>
      </main>
    </div>;
}